import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=5ded95c8&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&id=5ded95c8&lang=scss&scoped=true&"
import style1 from "./Product.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ded95c8",
  null
  
)

export default component.exports